import React from "react";
import OptimizedComponent from "./optimizedComponent";
import { translateService, stateService, signService, sessionService } from "../services/imports";
import { states } from "../models/states";
import { LoadingButton } from "./formcontrols/imports";

export const organizationName = (o) =>
  (o && (o.name || o.alias)) || translateService.t("organization.unnamed");

// A corporate (hrms) login with no active workspace picks an organization
// (share-prompt task 16): only an enrolled one can be entered; the first time
// in one asks before its primary workspace is made. With none enrolled it says
// so and still shows the list.
export default class OrganizationPicker extends OptimizedComponent {
  state = { organizations: [], confirm: null, busy: null, error: null, loaded: false };

  t = (k, ...a) => translateService.t(`organization.${k}`, ...a);

  componentDidMount() {
    this.secureSubscription(
      stateService.getState(states.allWorkSpaces).subscribe((data) =>
        this.setState({ organizations: (data && data.organizations) || [], loaded: !!(data && data.organizations) })
      )
    );
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.clearSubscriptions();
  }

  enter = (organization) => {
    if (organization.primaryWorkspaceExposedId == null && this.state.confirm !== organization.organizationId) {
      this.setState({ confirm: organization.organizationId, error: null });
      return;
    }
    this.setState({ busy: organization.organizationId, error: null });
    // a successful switch replaces the picker by the documents
    sessionService.enterOrganization(organization).then(
      () => !this.unmounted && this.setState({ busy: null, confirm: null }),
      (e) =>
        !this.unmounted &&
        this.setState({ busy: null, confirm: null, error: signService.problemMessage(e, this.t("enterError")) })
    );
  };

  render() {
    const t = this.t;
    const { organizations, confirm, busy, error, loaded } = this.state;
    const enrolled = organizations.filter((o) => o.enrolled);
    return (
      <section className={`organization-picker ${translateService.key}`} aria-labelledby="organization-picker-title">
        <h2 id="organization-picker-title" className="title">
          {t("pickTitle")}
        </h2>
        {loaded && !organizations.length && <p>{t("noneAtAll")}</p>}
        {loaded && organizations.length > 0 && !enrolled.length && <p>{t("noneEnrolled")}</p>}
        {error && (
          <p className="organization-picker__error" role="alert">
            {error}
          </p>
        )}
        <ul>
          {organizations.map((o, index) => (
            <li key={o.organizationId || `${o.alias}-${index}`} className={index % 2 === 0 ? "bg" : ""}>
              <span className="organization-picker__name">{organizationName(o)}</span>
              {!o.enrolled ? (
                <span className="organization-picker__note">{t("notEnrolled")}</span>
              ) : confirm === o.organizationId ? (
                <span className="organization-picker__confirm buttons">
                  <span>{t("firstTime", organizationName(o))}</span>
                  <LoadingButton
                    type="button"
                    className="button background-color-two color-white"
                    loading={busy === o.organizationId}
                    disabled={!!busy}
                    onClick={() => this.enter(o)}
                  >
                    {t("continue")}
                  </LoadingButton>
                  <LoadingButton
                    type="button"
                    className="button background-color-one color-white"
                    disabled={!!busy}
                    onClick={() => this.setState({ confirm: null })}
                  >
                    {translateService.t("common.cancell")}
                  </LoadingButton>
                </span>
              ) : (
                <span className="buttons">
                  <LoadingButton
                    type="button"
                    className="button background-color-two color-white"
                    loading={busy === o.organizationId}
                    disabled={!!busy}
                    onClick={() => this.enter(o)}
                  >
                    {t("open")}
                  </LoadingButton>
                </span>
              )}
            </li>
          ))}
        </ul>
      </section>
    );
  }
}
